import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import Html from 'slate-html-serializer';
import BlockTypes, { CONTINUOUS_BLOCK } from '../../../types/BlockTypes';
import StyleTypes from '../../../types/StyleTypes';
import { BLOCK, TEXT, MARK } from '../../../types/SlateTypes';
import getDataDepth from '../utils/getDataDepth';
import tagNames from '../utils/tagNames';
import makeDefaultNodeDeserializers from '../utils/makeDefaultNodeDeserializers';
import generateBlockId from '../../utils/generateBlockId';
var WRAPPED_BLOCKS = Object.entries(CONTINUOUS_BLOCK).reduce(function (memo, _ref) {
  var _ref2 = _slicedToArray(_ref, 2),
      key = _ref2[0],
      value = _ref2[1];

  return _objectSpread({}, memo, _defineProperty({}, value, key));
}, {});
var DETECTION_REGEX = /list-?type-bullet|list-?type-quote|list-?type-number|list-?type-code|data-emoji-ch|gutter-author-d-/i;

function listTypeToBlock(element) {
  if (/list-?type-quote/.test(element.className)) {
    return BlockTypes.QUOTES;
  } else if (/list-?type-bullet/.test(element.className)) {
    return BlockTypes.UL;
  } else if (/list-?type-number/.test(element.className)) {
    return BlockTypes.OL;
  }

  return BlockTypes.UL;
}

function listItemTypeToBlock(element) {
  var parentType = listTypeToBlock(element.closest('ul, ol'));
  return WRAPPED_BLOCKS[parentType];
}

var LIST = function LIST(el, next) {
  var depth = getDataDepth(el);
  return {
    object: BLOCK,
    type: listTypeToBlock(el),
    data: {
      id: generateBlockId(),
      depth: depth
    },
    nodes: next(el.childNodes)
  };
};

var TAGNAME_TO_BLOCK = _objectSpread({}, tagNames.TO_BLOCK, {
  DIV: function DIV(el, next) {
    if (!el.parentNode) {
      return {
        object: BLOCK,
        type: BlockTypes.UNSTYLED,
        data: {
          id: generateBlockId()
        },
        nodes: next(el.childNodes)
      };
    }

    return next(el.childNodes);
  },
  BR: function BR(el, next) {
    if (el.parentElement && el.parentElement.tagName === 'DIV') {
      return next(el.childNodes);
    }

    return TAGNAME_TO_ENTITY[el.tagName] && TAGNAME_TO_ENTITY[el.tagName](el);
  },
  CODE: BlockTypes.CODES,
  SPAN: function SPAN(el, next) {
    if (el.classList.contains('inline-code')) {
      return {
        object: MARK,
        type: StyleTypes.CODE,
        nodes: next(el.childNodes)
      };
    } else if (el.parentElement && el.parentElement.tagName === 'CODE') {
      return {
        object: BLOCK,
        type: BlockTypes.CODE,
        data: {
          id: generateBlockId()
        },
        nodes: next(el.childNodes)
      };
    }

    return next(el.childNodes);
  },
  IMG: function IMG(el, next) {
    if (el.dataset.emojiCh) {
      return {
        object: TEXT,
        text: el.dataset.emojiCh
      };
    }

    return {
      object: BLOCK,
      type: BlockTypes.IMAGE,
      data: {
        id: generateBlockId(),
        url: el.src,
        width: parseInt(el.getAttribute('width'), 10) || el.getAttribute('width') || el.style.width
      }
    };
  },
  UL: LIST,
  OL: LIST,
  LI: function LI(el, next) {
    var parent = el.closest('ul, ol');
    var depth = parent ? parseInt(parent.dataset.depth, 10) || 0 : 0;
    return {
      object: BLOCK,
      type: listItemTypeToBlock(el),
      data: {
        id: generateBlockId(),
        depth: depth
      },
      nodes: next(el.childNodes)
    };
  }
});

var TAGNAME_TO_ENTITY = _objectSpread({}, tagNames.TO_ENTITY);

var TAGNAME_TO_MARK = _objectSpread({}, tagNames.TO_MARK, {
  A: function A(el, next) {// Insert link here
  }
});

var nodeDeserializers = makeDefaultNodeDeserializers({
  TAGNAME_TO_BLOCK: TAGNAME_TO_BLOCK,
  TAGNAME_TO_ENTITY: TAGNAME_TO_ENTITY,
  TAGNAME_TO_MARK: TAGNAME_TO_MARK
});
export default function makeDropboxPaperDeserializer(editor) {
  return {
    canDeserialize: function canDeserialize(_ref3) {
      var type = _ref3.type,
          html = _ref3.html;
      return type === 'html' && DETECTION_REGEX.test(html);
    },
    deserialize: function deserialize(_ref4) {
      var rawHtml = _ref4.html;
      var html = rawHtml.replace(/(?:\r\n|\n\r)/g, '\n');
      var deserializer = new Html({
        rules: [{
          deserialize: nodeDeserializers
        }],
        defaultBlock: BlockTypes.UNSTYLED
      });
      return deserializer.deserialize(html);
    }
  };
}